// Generated by Melange


const emptyBankAccount = {
  iban: "",
  bank_name: "",
  bic: "",
  default: false
};

export {
  emptyBankAccount ,
}
/* No side effect */
